import React from 'react';

const NotFound = props => <div>Page not found!</div>;

export default NotFound;
